export default "__VITE_ASSET__CUSXZtGV__"